import { normalize } from 'normalizr';
import { camelizeKeys } from 'humps';

import * as api from './api';
import { showError } from 'actions/actionCreators/snackbarActions';
import * as eventTypes from './eventTypes';
import * as actionTypes from './actionTypes';
import * as paymentPlanTypes from 'features/offer/edit/financials/paymentPlan/actionTypes';
import { sendHttpCommandAndWaitForEvent } from 'actions/actionCreators/httpActions';
import { getContractsForRestructuring, getFilters } from './selectors';
import schemas from '../../../../utils/schemas';

export const loadContractsKey = filters => {
  return JSON.stringify({ ...filters });
};

export const loadLeasingContractList = (filters, page, pageSize) => {
  return async (dispatch, getState) => {
    const { loading, loaded } = getContractsForRestructuring(filters, getState());
    let shouldCallApi = !loaded && !loading;
    if (!shouldCallApi) {
      return;
    }

    const key = loadContractsKey(filters);
    dispatch({ type: actionTypes.LOAD_CONTRACT_LIST_STARTED, key, page, pageSize });

    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(api.getLeasingContractList(filters), null, [eventTypes.CONTRACT_LIST_RETRIEVED])
      );
      const leasingContractList = event.eventBody.list;
      if (event.ok) {
        const camelizedJson = camelizeKeys(leasingContractList);
        const payload = Object.assign({}, normalize(camelizedJson, schemas.contractsForRestructuring));

        dispatch({
          type: actionTypes.LOAD_CONTRACT_LIST_SUCCEEDED,
          key,
          page,
          totalCount: leasingContractList.length,
          totalPages: 1,
          ...payload
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: actionTypes.LOAD_CONTRACT_LIST_FAILED, key, page, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
};

export const saveLeasingContract = contractSelected => {
  return async dispatch => {
    dispatch({ type: actionTypes.SAVE_LEASING_CONTRACT_STARTED });
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(api.saveLeasingContract(contractSelected), null, [eventTypes.RESTRUCTURING_OFFER_CREATED])
      );
      if (event.ok) {
        dispatch({ type: actionTypes.SAVE_LEASING_CONTRACT_SUCCEEDED });
        return event;
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
};

export const recomputeSimulationsForModification = offer => {
  return async dispatch => {
    dispatch({ type: actionTypes.SAVE_LEASING_CONTRACT_STARTED });
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(api.recomputeSimulationsForModification(offer), null, [eventTypes.RESTRUCTURING_OFFER_CREATED])
      );
      if (event.ok) {
        dispatch({ type: actionTypes.SAVE_LEASING_CONTRACT_SUCCEEDED });
        dispatch({ type: paymentPlanTypes.DOCUMENT_SCHEDULE_PARAMS_INVALIDATED });
        return event;
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
};

export const loadLeasingOfferContractData = (documentId, siteId) => {
  return async dispatch => {
    dispatch({ type: actionTypes.LOAD_CONTRACT_INFORMATION_STARTED });
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.getLeasingOfferContractData(documentId, siteId),
          null,
          [eventTypes.CONTRACT_DATA_RETRIEVED],
          false
        )
      );
      if (event.ok) {
        const leasingContract = event.eventBody.contractData;
        dispatch({ type: actionTypes.LOAD_CONTRACT_INFORMATION_SUCCESS });
        return leasingContract;
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
};

export function emptyContractListInState(filters) {
  return dispatch => {
    const key = loadContractsKey(filters);
    dispatch({ type: actionTypes.EMPTY_CONTRACTS_FOR_RESTRUCTURING, key });
  };
}

export const saveFilters = filters => {
  return async (dispatch, getState) => {
    const stateFilters = getFilters(getState());
    if (stateFilters.uniqueId !== filters.uniqueId || stateFilters.partnerName !== filters.partnerName)
      dispatch({ type: actionTypes.SAVE_CONTRACT_LIST_FILTERS, filters });
  };
};
